
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.534 36.365l-2.279-2.294-1.431 1.421 2.271 2.287c-3.62 3.227-8.376 5.205-13.596 5.205-5.298 0-10.116-2.038-13.756-5.35l2.126-2.142-1.432-1.421-2.119 2.133C4.035 32.57 2.016 27.773 2.016 22.5c0-5.274 2.02-10.07 5.302-13.706l2.12 2.134 1.43-1.42-2.125-2.142c3.64-3.313 8.458-5.35 13.756-5.35 5.221 0 9.975 1.978 13.597 5.204l-2.272 2.288 1.431 1.42 2.28-2.294c3.37 3.652 5.449 8.515 5.449 13.866 0 5.35-2.079 10.212-5.45 13.864M22.5 0C10.093 0 0 10.094 0 22.5 0 34.908 10.093 45 22.5 45 34.905 45 45 34.907 45 22.5 45 10.095 34.906 0 22.5 0m.867 32.787c-.24.932-.42 1.63-.477 1.882a.753.753 0 01-.035.122.852.852 0 01-.036-.121c-.056-.253-.236-.95-.476-1.883-.61-2.363-2.037-7.894-2.037-8.787v-.363a4.512 4.512 0 005.098.202V24c0 .894-1.428 6.425-2.037 8.788m-1.024-19.55c.24-.932.42-1.63.476-1.883a.895.895 0 01.036-.121.768.768 0 01.035.12c.056.254.237.952.477 1.885.49 1.902 1.51 5.857 1.89 7.791-.332.863-1.217 1.487-2.264 1.487-1.26 0-2.316-.907-2.404-2.065l-.004-.055c.445-2.069 1.316-5.445 1.758-7.158m4.614 5.168l-2.514-9.558-.186-.19a1.632 1.632 0 00-1.24-.467c-.376.022-.932.19-1.45.862-.715.932-1.553 4.049-1.794 4.99l-1.564 6.286.26.37c-.114.602-.179 1.058-.179 1.325V24c0 .96.77 4.135 2.101 9.29.232.902.406 1.576.462 1.821.286 1.279 1.202 1.703 1.873 1.703.042 0 .084-.002.125-.005h.007c.665.048 1.693-.337 2-1.698.054-.245.228-.919.461-1.82 1.33-5.156 2.101-8.33 2.101-9.291v-1.976c0-.19-.04-.493-.098-.856a4.09 4.09 0 00.098-.876 4.11 4.11 0 00-.463-1.886"}})])
          )
        }
      }
    